import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core';

import Transition from '../../../../components/dialogs/Transition';
import { generalStyles } from '../util';
import { dialogStyles } from './dialogStyles';

const styles = () => {
	return {
		...generalStyles,
		...dialogStyles,
		dialogSubmitButton: {
			...dialogStyles.dialogSubmitButton,
			minWidth: '30%',
		},
		dialogCloseButton: {
			...dialogStyles.dialogCloseButton,
			minWidth: '30%',
		},
	};
};

class MobileImageZoomDialog extends Component {
	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { open, classes, imageSrcUrl } = this.props;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				fullScreen={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<DialogContent dividers={true} style={{ position: 'relative', padding: 5 }}>
					<img src={imageSrcUrl} alt="zoom" width="100%" />
				</DialogContent>

				<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
					<div style={{ display: 'flex', width: '100%', padding: '0px 2vw' }}>
						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.handleClose}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

MobileImageZoomDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object,
	imageSrcUrl: PropTypes.string,
};
export default _.flow([withStyles(styles)])(MobileImageZoomDialog);
